<template>
  <div id="app">
    <div>
      <!-- 別タブ -->
      <div v-if="$route.meta.isSinglePage">
        <router-view></router-view>
      </div>
      <!-- メニューあり画面 -->
      <div v-else-if="$route.path !== '/'" id="main">
        <div class="main-header">
          <main-header2 :appName="'sinopsadmin'"></main-header2>
        </div>
        <div id="app_wrapper" class="app-wrapper" @click="clickAppWrapper($event)">
          <div class="main-container">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>

    <loading></loading>
    <global-error></global-error>
    <network-error></network-error>
    <auth-error></auth-error>
  </div>
</template>

<style scoped>
#app {
  user-select: none;
}

.app-wrapper {
  height: calc(100vh - 50px);
}

.main-header {
  height: 50px;
  padding: 10px 0;
}
.main-container {
  height: 100%;
  overflow: hidden;
  margin-top: 50px;
}
</style>

<script>
import MainHeader2 from './components/header/MainHeader2'

export default {
  name: 'App',
  components: {
    MainHeader2,
  },
  data () {
    return {
      environment: process.env.NODE_ENV,
      commonUrl: process.env.VUE_APP_COMMON_APP_URL,
      zaikoUrl: process.env.VUE_APP_ZAIKO_APP_URL,
    }
  },
  computed: {
    isLogined () {
      return !!this.$store.getters['auth/isLogined'] && !this.$route.meta.isPublic && this.$store.state.header.user
    },
  },
  created () {
    document.title = "sinops-CLOUD AI値引"
  },
  mounted () {
    this.setFontSize()

    if (window.innerWidth < 1025) {
      // スマホの場合はメニューを隠す
      this.loopHideMainMenu()
    }

    this.$store.commit('setEnvironment', this.environment)
    this.$store.commit('setAppName', process.env.VUE_APP_NAME)
  },
  methods: {
    /**
     * 全体のフォントサイズを変更する
     */
    setFontSize () {
      const clientSettingValue = window.localStorage.getItem('sinops.cloud.client_setting')
      if (clientSettingValue) {
        const clientSetting = JSON.parse(clientSettingValue)
        this.changeGlobalFontSize(clientSetting.font_size)
      } else {
        this.changeGlobalFontSize('18px')
      }
    },
    /**
     * PCはメニューを閉じる
     * @param {Object} e イベント
     */
    clickAppWrapper (e) {
      if (e.target.id !== 'app_wrapper' || window.innerWidth > 1024) {
        return
      }

      e.target.classList.add('hide-sidebar')
    },
    /**
     * 描画待ち
     */
    loopHideMainMenu () {
      const ele = document.getElementById('app_wrapper')
      if (ele) {
        ele.classList.add('hide-sidebar')
      } else {
        setTimeout(() => {
          this.loopHideMainMenu()
        }, 200)
      }
    }
  }
}
</script>
